import * as React from "react";
import { Modal } from "components/bootstrap";
import { Spinner } from "components/common";
import EventDefinitionFormContainer from "components/event-definitions/event-definition-form/EventDefinitionFormContainer";
import DefinitionFormControls from "./DefinitionFormControls";
function DefinitionFormModal({
  eventDefinition = void 0,
  loading = false,
  onClose,
  action = "edit",
  onSubmit,
  onCancel
}) {
  return /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "xlarge", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, `${(eventDefinition == null ? void 0 : eventDefinition.id) ? "Edit" : "New"} Event Definition`)), /* @__PURE__ */ React.createElement(Modal.Body, null, loading ? /* @__PURE__ */ React.createElement(Spinner, { text: "Loading event definition" }) : /* @__PURE__ */ React.createElement(
    EventDefinitionFormContainer,
    {
      eventDefinition,
      action,
      onCancel,
      formControls: DefinitionFormControls,
      onSubmit
    }
  )));
}
export default DefinitionFormModal;
